<template>
  <div class="w1200 zhaogu-page">
    <div class="page-bar">
      <span class="back-btn" @click="goBack">← 返回</span>
    </div>
    <div class="page-title">实战合同存档</div>

    <!-- 顶部横幅：说明 + 统计 -->
    <div class="hero">
      <div class="hero-left">
        <div class="hero-tit"><i class="el-icon-document-checked" /> 实战合同存档公示</div>
        <div class="hero-desc">帮扶实战方案 + 实战票 + 承诺签名手持照 + 合同签名照，投注站按众筹招股上传，一次招股一份归档留痕，公示可查。</div>
      </div>
      <div class="hero-stats">
        <div class="stat-item">
          <div class="num">{{ stat.total || 0 }}</div>
          <div class="lab">存档总数</div>
        </div>
        <div class="stat-item">
          <div class="num">{{ stat.complete || 0 }}</div>
          <div class="lab">四件套齐全</div>
        </div>
        <div class="stat-item">
          <div class="num">{{ stat.shopCount || 0 }}</div>
          <div class="lab">投注站</div>
        </div>
        <div class="stat-item">
          <div class="num latest">{{ latestDate }}</div>
          <div class="lab">最近存档</div>
        </div>
      </div>
    </div>

    <!-- 筛选区 -->
    <div class="filter-bar">
      <el-input v-model="query.bettingShop" placeholder="投注站地址" clearable size="small" class="f-item" prefix-icon="el-icon-location-outline" @keyup.enter.native="onSearch" />
      <el-input v-model="query.bettingShopNumber" placeholder="投注站编号" clearable size="small" class="f-item" prefix-icon="el-icon-office-building" @keyup.enter.native="onSearch" />
      <el-input v-model="query.issueNumber" placeholder="期号" clearable size="small" class="f-item" prefix-icon="el-icon-date" @keyup.enter.native="onSearch" />
      <el-date-picker v-model="dateRange" type="daterange" size="small" class="f-item"
        range-separator="至" start-placeholder="存档开始" end-placeholder="存档结束"
        value-format="yyyy-MM-dd" @change="onDateChange" />
      <el-button type="primary" size="small" icon="el-icon-search" @click="onSearch">搜索</el-button>
      <el-button size="small" icon="el-icon-refresh" @click="onReset">重置</el-button>
    </div>

    <el-table :data="list" v-loading="loading" stripe
      :header-cell-style="{ 'textAlign': 'center' }" :cell-style="{ 'textAlign': 'center' }">
      <template slot="empty">
        <div class="table-empty">
          <i class="el-icon-folder-opened" />
          <p>暂无合同存档，投注站完成众筹招股四件套上传后自动归档</p>
        </div>
      </template>
      <el-table-column prop="createTime" label="日期" width="105">
        <template slot-scope="{ row }"><span class="strong">{{ shortDate(row.createTime) }}</span></template>
      </el-table-column>
      <el-table-column label="彩票投注站" width="110" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="maskName(row.nickname) || maskName(row.identityCardName)" class="strong">{{ maskName(row.nickname) || maskName(row.identityCardName) }}</span>
          <span v-else class="empty-cell">—</span>
        </template>
      </el-table-column>
      <el-table-column prop="bettingShop" label="投注站地址" min-width="190" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.bettingShop">{{ row.bettingShop }}</span>
          <span v-else class="empty-cell">—</span>
        </template>
      </el-table-column>
      <el-table-column prop="bettingShopNumber" label="投注站编号" width="120" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.bettingShopNumber" class="code-chip">{{ row.bettingShopNumber }}</span>
          <span v-else class="empty-cell">—</span>
        </template>
      </el-table-column>
      <el-table-column label="众筹详情" min-width="180" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.issueNumber || row.lotteryTypeName" class="cf-detail">
            <i class="el-icon-collection-tag" />众筹期：{{ row.lotteryTypeName || '彩票' }}+{{ row.issueNumber || '-' }}
          </span>
          <span v-else class="empty-cell">—</span>
        </template>
      </el-table-column>
      <el-table-column label="分红到账详情" min-width="160" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.actualTicketAfterTaxAmount != null" class="money">
            <i class="el-icon-coin" />税后实战票 ¥{{ row.actualTicketAfterTaxAmount }}
            <em v-if="row.actualTicketProfitLossAmount != null" :class="profitClass(row.actualTicketProfitLossAmount)">
              {{ row.actualTicketProfitLossAmount >= 0 ? '+' : '' }}{{ row.actualTicketProfitLossAmount }}
            </em>
          </span>
          <span v-else class="empty-cell">—</span>
        </template>
      </el-table-column>
      <el-table-column label="存档合同" width="130" fixed="right">
        <template slot-scope="{ row }">
          <el-tag v-if="archiveDone(row)" size="mini" type="success" effect="light"><i class="el-icon-check" /> 已存档</el-tag>
          <el-tooltip v-else content="四件套尚未齐全，点击查看缺项" placement="top">
            <el-tag size="mini" type="warning" effect="light">部分上传</el-tag>
          </el-tooltip>
          <el-button type="text" class="view-btn" icon="el-icon-view" @click="openDetail(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="fenye">
      <span class="zhanwei"></span>
      <el-pagination v-if="total > 0" background layout="prev, pager, next" :total="total"
        :page-size="pageSize" :current-page="pageNum" @current-change="onPage" />
      <span class="zhanwei"></span>
    </div>

    <!-- 四件套详情弹窗 -->
    <el-dialog title="帮扶四件套档案" :visible.sync="detailVisible" width="720px" @close="current = null">
      <div v-if="current" class="contract-detail">
        <div class="cd-line"><span>投注站</span><b>{{ current.bettingShop || '-' }}（{{ current.bettingShopNumber || '-' }}）</b></div>
        <div class="cd-line"><span>期号</span><b>{{ current.issueNumber || '-' }}</b></div>
        <div class="cd-line"><span>存档时间</span><b>{{ current.createTime || '-' }}</b></div>
        <div class="cd-grid">
          <div class="cd-block">
            <div class="cd-label">帮扶实战方案</div>
            <a v-if="isUrl(current.practicalSchemes)" :href="$img(current.practicalSchemes)" target="_blank" class="cd-link">下载方案文件</a>
            <div v-else-if="current.practicalSchemes" class="cd-text">{{ current.practicalSchemes }}</div>
            <span v-else class="cd-empty">未上传</span>
          </div>
          <div class="cd-block">
            <div class="cd-label">实战票</div>
            <img v-if="current.practicalTicket" :src="$img(current.practicalTicket)" class="cd-img" alt="实战票" />
            <span v-else class="cd-empty">未上传</span>
          </div>
          <div class="cd-block">
            <div class="cd-label">承诺签名手持照</div>
            <img v-if="current.signature" :src="$img(current.signature)" class="cd-img" alt="签名照" />
            <span v-else class="cd-empty">未上传</span>
          </div>
          <div class="cd-block">
            <div class="cd-label">合同签名照</div>
            <img v-if="current.contractSignature" :src="$img(current.contractSignature)" class="cd-img" alt="合同照" />
            <span v-else class="cd-empty">未上传</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { contractArchiveList } from '@/api/apply'
import request from '@/axios/http'

export default {
  data() {
    return {
      query: { bettingShop: '', bettingShopNumber: '', issueNumber: '', startTime: '', endTime: '' },
      dateRange: [],
      list: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      loading: false,
      stat: {},
      detailVisible: false,
      current: null,
    }
  },
  computed: {
    latestDate() {
      const t = this.stat.latestTime
      return t ? String(t).slice(0, 10) : '—'
    },
  },
  mounted() {
    this.loadStat()
    this.loadData()
  },
  methods: {
    goBack() {
      this.$router.push('/sttzzbfzx')
    },
    loadStat() {
      request({ url: '/stage-api/assist/betting/shop/contract/archive/stat', method: 'get' }).then(res => {
        this.stat = (res && res.data) || {}
      }).catch(() => {
        this.stat = {}
      })
    },
    onDateChange(val) {
      if (val && val.length === 2) {
        this.query.startTime = val[0] + ' 00:00:00'
        this.query.endTime = val[1] + ' 23:59:59'
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
    onSearch() {
      this.pageNum = 1
      this.loadData()
    },
    onReset() {
      this.query = { bettingShop: '', bettingShopNumber: '', issueNumber: '', startTime: '', endTime: '' }
      this.dateRange = []
      this.pageNum = 1
      this.loadData()
    },
    onPage(page) {
      this.pageNum = page
      this.loadData()
    },
    loadData() {
      this.loading = true
      const params = { ...this.query, pageNum: this.pageNum, pageSize: this.pageSize }
      contractArchiveList(params).then(res => {
        this.list = (res && res.rows) || []
        this.total = (res && res.total) || 0
      }).catch(() => {
        this.list = []
        this.total = 0
      }).finally(() => {
        this.loading = false
      })
    },
    openDetail(row) {
      this.current = row
      this.detailVisible = true
    },
    archiveDone(row) {
      return !!(row.practicalSchemes && row.practicalTicket && row.signature && row.contractSignature)
    },
    profitClass(v) {
      return Number(v) >= 0 ? 'up' : 'down'
    },
    shortDate(t) {
      if (!t) return '—'
      return String(t).slice(0, 10)
    },
    maskName(v) {
      if (!v) return ''
      const s = String(v)
      if (s.length <= 1) return s + '**'
      return s.charAt(0) + '**'
    },
    isUrl(v) {
      if (!v) return false
      return /^(https?:)?\//.test(v) || v.indexOf('.') > -1
    },
  }
}
</script>

<style lang="scss" scoped>
.hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 14px;
  padding: 20px 26px;
  border-radius: 12px;
  background: linear-gradient(120deg, #1e63b4 0%, #3a8bd4 55%, #5aa7e0 100%);
  color: #ffffff;
  box-shadow: 0 6px 18px rgba(30, 99, 180, 0.25);

  .hero-left {
    flex: 1;
    min-width: 0;
  }

  .hero-tit {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;

    i {
      margin-right: 8px;
      color: #ffe28a;
    }
  }

  .hero-desc {
    margin-top: 8px;
    font-size: 13px;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.85);
  }

  .hero-stats {
    display: flex;
    gap: 14px;
    flex: 0 0 auto;
  }

  .stat-item {
    min-width: 84px;
    padding: 10px 12px;
    text-align: center;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.22);

    .num {
      font-size: 20px;
      font-weight: bold;
      color: #ffffff;

      &.latest {
        font-size: 14px;
        line-height: 20px;
        color: #ffe28a;
      }
    }

    .lab {
      margin-top: 4px;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.75);
    }
  }
}

.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  margin-top: 14px;

  .f-item {
    width: 170px;
  }
}

.fenye {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .zhanwei {
    width: 25%;
  }
}

.zhaogu-page {
  background: #ffffff;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-radius: 8px;

  .page-bar {
    margin-bottom: 10px;
    position: absolute;
  }

  .back-btn {
    display: inline-block;
    cursor: pointer;
    color: #347caf;
    font-size: 14px;
    padding: 6px 14px;
    border: 1px solid #347caf;
    border-radius: 5px;
    transition: all 0.2s;

    &:hover {
      background-color: #347caf;
      color: #ffffff;
    }
  }

  .page-title {
    font-size: 22px;
    font-weight: bold;
    color: #347caf;
    text-align: center;
    padding: 10px 0 20px;
    border-bottom: 2px solid #347caf;
    margin-bottom: 20px;
  }
}

.strong {
  font-weight: 600;
  color: #333;
}

.empty-cell {
  color: #c0c4cc;
}

.code-chip {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 10px;
  background: #eef4ff;
  color: #1565d8;
  font-size: 12px;
}

.cf-detail {
  color: #347caf;

  i {
    margin-right: 4px;
  }
}

.money {
  color: #d9752b;

  i {
    margin-right: 4px;
  }

  em {
    margin-left: 6px;
    font-style: normal;
    font-weight: 600;

    &.up {
      color: #d8452e;
    }

    &.down {
      color: #1e9e57;
    }
  }
}

.view-btn {
  margin-left: 6px;
  padding: 0;
}

.table-empty {
  padding: 28px 0 10px;
  color: #909399;

  i {
    font-size: 42px;
    color: #c6d4e6;
  }

  p {
    margin-top: 8px;
    font-size: 13px;
  }
}

.contract-detail {
  .cd-line {
    display: flex;
    padding: 6px 0;
    border-bottom: 1px dashed #e4e7ed;

    span {
      width: 80px;
      color: #888;
      flex: 0 0 auto;
    }

    b {
      color: #333;
      font-weight: 500;
    }
  }

  .cd-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px 18px;
    margin-top: 14px;
  }

  .cd-block {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 10px 12px;
    background: #fbfdff;

    .cd-label {
      color: #347caf;
      font-weight: bold;
      margin-bottom: 6px;
    }

    .cd-text {
      white-space: pre-wrap;
      word-break: break-all;
      color: #333;
      background: #f7f9fc;
      border-radius: 6px;
      padding: 8px;
      max-height: 120px;
      overflow: auto;
    }

    .cd-link {
      color: #347caf;
    }

    .cd-img {
      width: 100%;
      height: 180px;
      object-fit: contain;
      border-radius: 6px;
    }

    .cd-empty {
      color: #999;
    }
  }
}

::v-deep .el-table th {
  background: linear-gradient(180deg, #eef4ff 0%, #e3edfb 100%);
  color: #1565d8;
  font-weight: bold;

  .cell {
    text-align: center;
  }
}

::v-deep .el-table td,
::v-deep .el-table th.is-leaf {
  border-bottom: 1px solid rgba(21, 101, 216, 0.12);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #f5f9ff;
}
</style>
